const IndexHome = () => import("./components/base/IndexHome");
const IndexAccount = () => import("./components/account/IndexAccount");
const IndexAnalyse = () => import("./components/account/IndexAnalyse");
const IndexFragen = () => import("./components/intern/IndexFragen");
const IndexZertifzierung = () =>
  import("./components/intern/IndexZertifzierung");

const IndexPruefung = () => import("./components/account/IndexPruefung");
const IndexRechnung = () => import("./components/account/IndexRechnung");
const IndexHinweise = () => import("./components/account/IndexHinweise");
const IndexDownloads = () => import("./components/account/IndexDownloads");
const DirectLogin = () => import("./components/account/DirectLogin");
const IndexInfo = () => import("./components/static/IndexInfo");
const IndexLogout = () => import("./components/static/IndexLogout");

const routes = [
  {
    path: "/",
    name: "index",
    component: IndexHome,
    meta: { guest: true },
  },
  {
    path: "/logout",
    name: "logout",
    component: IndexLogout,
    meta: { guest: true },
  },
  {
    path: "/zertifizierung/id/:token",
    name: "zertifizierung",
    component: IndexZertifzierung,
    meta: { guest: true },
  },
  {
    path: "/certstart/id/:token",
    name: "zertifizierungstart",
    component: IndexZertifzierung,
    meta: { guest: true },
  },
  {
    path: "/vertragsschutz",
    name: "vertragsschutz",
    component: IndexAccount,
    meta: { guest: true },
  },
  {
    path: "/rechnung",
    name: "rechnung",
    component: IndexRechnung,
    meta: { guest: true },
  },
  {
    path: "/info/:type",
    name: "info",
    component: IndexInfo,
    meta: { guest: true },
  },
  {
    path: "/premium/start_login/:token/:id",
    name: "directlogin",
    component: DirectLogin,
    meta: { guest: true },
  },
  {
    path: "/fragen/:id",
    name: "interncheck",
    component: IndexFragen,
    meta: { guest: true },
  },
  {
    path: "/vertragscheck",
    name: "vertragscheck",
    component: IndexAnalyse,
    meta: { guest: true },
  },
  {
    path: "/hinweise",
    name: "hinweise",
    component: IndexHinweise,
    meta: { guest: true },
  },
  {
    path: "/downloads",
    name: "downloads",
    component: IndexDownloads,
    meta: { guest: true },
  },
  {
    path: "/pruefung",
    name: "pruefung",
    component: IndexPruefung,
    meta: { guest: true },
  },
];

export default routes;
